var _style, _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileBg2Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237 110",
    style: {
      enableBackground: "new 0 0 237 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:5.000000e-02;}\n\t.st1{clip-path:url(#SVGID_00000155114351740551450850000004558083459499130770_);}\n\t.st2{fill:none;stroke:#F3F5FF;stroke-width:5;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M138.1,0h86.7c6.7,0,12.1,5.4,12.1,12v86c0,6.6-5.4,12-12.1,12h-86.7V0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083055417884333929850000009374221564186732455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083055417884333929850000009374221564186732455_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.9,10c0,40.6-33.2,73.5-74.1,73.5S140.6,50.6,140.6,10s33.2-73.5,74.1-73.5S288.9-30.6,288.9,10z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.7,10c0,30.7-25.1,55.5-56,55.5s-56-24.9-56-55.5s25.1-55.5,56-55.5S270.7-20.7,270.7,10z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.6,10c0,21.8-17.8,39.5-39.8,39.5S174.9,31.8,174.9,10c0-21.8,17.8-39.5,39.8-39.5S254.6-11.8,254.6,10 z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.5,138.1c0,21.8-17.8,39.5-39.8,39.5s-39.8-17.7-39.8-39.5s17.8-39.5,39.8-39.5 S246.5,116.2,246.5,138.1z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBg2Dark);
export default __webpack_public_path__ + "static/media/tile_bg_2-dark.3bfbb8d2d0faff44d4b5d77b5f3f1db7.svg";
export { ForwardRef as ReactComponent };